<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Immediate Families"
      text="Create immediate family"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required|max:80|nameAllowedFormat'"
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"  
                outlined
                :class="{
                  'required':!name
                }"
                @input="name = name.toUpperCase()"
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <span> Citizenship? </span>
              <v-radio-group
                v-model="isCitizen"
                class="mt-0"
                row
                @change="ic=null,passportNo=null"
              >
                <v-radio
                  label="Non-citizen"
                  :value="0"
                />
                <v-radio
                  label="Citizen"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            
            <v-col
              cols="6"
              class="pb-0"
            >
              <v-text-field 
                v-show="isCitizen === 1"
                v-model="ic"
                v-validate="isCitizen === 1 ? 'required|icDate|icLength' : ''"
                v-mask="'######-##-####'"
                label="IC"
                :error-messages="errors.collect('ic')"
                data-vv-name="ic"
                data-vv-as="ic"
                outlined
                :class="{
                  'required':!ic && isCitizen === 1
                }"
                @input="getBirthdayFromIC(ic)"
              />
              <v-text-field
                v-show="isCitizen === 0"
                v-model="passportNo"
                v-validate="isCitizen === 0 ? 'required' : ''"
                label="Passport No."
                :error-messages="errors.collect('isCitizen')"
                data-vv-name="isCitizen"
                data-vv-as="passport no"
                outlined
                :class="{
                  'required':!passportNo && isCitizen === 0
                }"
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="birthDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }"> 
                  <v-text-field
                    v-model="birthDateDisplay"
                    v-validate="'required'"
                    label="Birth Date"
                    :error-messages="errors.collect('birthDateDisplay')"
                    data-vv-name="birthDateDisplay"
                    data-vv-as="birth date"
                    readonly
                    outlined
                    class="label-position"
                    :class="{
                      'required':!birthDateDisplay
                    }"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="birthDate"
                  @input="birthDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="genderLookupUid"
                v-validate="'required'"
                :error-messages="errors.collect('gender')"
                :items="gender"
                data-vv-name="gender"
                data-vv-as="gender"
                item-text="value"
                item-value="lookup_uid"
                label="Gender"
                outlined
                :class="{
                  'required':!genderLookupUid
                }"
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-human-male-female
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="relationship"
                v-validate="'required'"
                :error-messages="errors.collect('relationship')"
                :items="relationships"
                data-vv-name="relationship"
                data-vv-as="relationship"
                item-text="name"
                item-value="id"
                label="Relationship"
                outlined
                :class="{
                  'required':!relationship
                }"
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="relationStatus"
                v-validate="'required'"
                :error-messages="errors.collect('relationStatus')"
                :items="relationStatuses"
                data-vv-name="relationStatus"
                data-vv-as="relation status"
                item-text="name"
                item-value="id"
                label="Relation Status"
                outlined
                :class="{
                  'required':!relationStatus
                }"
                @change="companyName = null;incomeTaxNo = null;occupation = null"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ data.item.name }}</span>
                    <span style="width:100px">{{ data.item.description }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-text-field
                v-show="relationStatus === 4"
                v-model="companyName"
                v-validate="relationStatus=== 4 && isCitizen === 1 ? 'required' : ''"
                label="Company Name"
                :error-messages="errors.collect('companyName')"
                data-vv-name="companyName"
                outlined
                data-vv-as="company name"
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-text-field
                v-show="relationStatus === 4"
                v-model="occupation"
                v-validate="relationStatus === 4 ? 'required' : ''"
                label="Occupation"
                :error-messages="errors.collect('occupation')"
                data-vv-name="occupation"
                data-vv-as="occupation"
                outlined
              />
            </v-col>

            <v-col
              :cols="relationStatus === 1 || relationStatus === 3 ? 12 : 6"
              class="pb-0"
            >
              <span> Disabled? </span>
              <v-radio-group
                v-model="isDisabled"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>

            <v-col
              v-if="relationStatus === 2"
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="educationLevel"
                v-validate="relationStatus === 2 ? 'required' : ''"
                :error-messages="errors.collect('educationLevel')"
                :items="educationLevels"
                data-vv-name="educationLevel"
                data-vv-as="education level"
                item-text="name"
                item-value="key"
                label="Education Level"
                outlined
              />
            </v-col>

            <v-col
              v-show="relationStatus === 4"
              cols="6"
              class="pb-0"
            >
              <v-text-field
                v-model="incomeTaxNo"
                v-validate="'length:13|validAlphanumeric'"
                :error-messages="errors.collect('incomeTaxNo')"
                data-vv-name="incomeTaxNo"
                data-vv-as="Income tax number"
                label="Income Tax No."
                outlined
                @input="incomeTaxNo = incomeTaxNo.toUpperCase()"
              />
            </v-col>

            <v-col
              v-if="relationship===2"
              cols="3"
              class="pb-0"
            >
              <span> Tax Relief? </span>
              <v-radio-group
                v-model="isTaxRelief"
                class="mt-0"
                row
                @change="isTaxRelief?taxReliefPercentage = 100 :taxReliefPercentage = 0"
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>

            <v-col
              v-if="relationship===2 && isTaxRelief"
              cols="3"
              class="pb-0"
            >
              <v-autocomplete
                v-model="taxReliefPercentage"
                :error-messages="errors.collect('taxReliefPercentage')"
                :items="percentages"
                data-vv-name="taxReliefPercentage"     
                data-vv-as="taxReliefPercentage"
                item-text="name"
                item-value="key"
                label="Percentage"
              />
            </v-col>

            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                :max-size-in-mb="10"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                accept-type=".pdf"    
                extension="ext:pdf"      
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mr-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      HelperFileInput: () => import('@/components/hris/helper/FileInput'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        name: null,
        isCitizen: 1,
        ic: null,
        passportNo: null,
        relationships: [],
        relationship: null,
        relationStatuses: [],
        relationStatus: null,
        birthDate: null,
        genderLookupUid: null,
        companyName: null,
        incomeTaxNo: null,
        occupation: null,
        isDisabled: 0,
        isTaxRelief: 1,
        taxReliefPercentage: 100,
        file: null,
        percentages: [
          { key: 50, name: '50 %' },
          { key: 100, name: '100 %' },
        ],
        birthDateMenu: false,
        educationLevel: null,
        educationLevels: [
          { key: 'PRIMARY', name: 'Primary' },
          { key: 'SECONDARY', name: 'Secondary' },
          { key: 'ALEVEL', name: 'A-Level' },
          { key: 'CERTIFICATE', name: 'Certificate' },
          { key: 'MATRICULATION', name: 'Matriculation' },
          { key: 'PREPARATORY_COURSES', name: 'Preparatory Courses' },
          { key: 'DIPLOMA', name: 'Diploma in Malaysia (excluding matriculation/ preparatory courses)' },
          { key: 'OVERSEAS_DIPLOMA', name: 'Overseas Diploma' },
          { key: 'DEGREE', name: 'Degree in Malaysia' },
          { key: 'OVERSEAS_DEGREE', name: 'Overseas Degree' },
          { key: 'MASTER', name: 'Master in Malaysia' },
          { key: 'OVERSEAS_MASTER', name: 'Overseas Master' },
          { key: 'DOCTORATE', name: 'Doctorate in Malaysia' },
          { key: 'OVERSEAS_DOCTORATE', name: 'Overseas Doctorate' },
        ],
      }
    },
    computed: {
      ...mapState('lookup', ['gender']),

      birthDateDisplay () {
        return this.birthDate ? this.$moment(this.birthDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.loading = true
     
        this.$validator.extend('icDate', {
          getMessage (field, args) {
            return 'Invalid IC Date'        
          },
          validate (value, args) {
            var y = parseInt(value.substr(0, 2))
            var m = parseInt(value.substr(2, 2))
            var d = parseInt(value.substr(4, 2))
            if (m === 0 || m > 12) { return false }
            var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
            // Adjust for leap years
            if (y % 400 === 0 || (y % 100 !== 0 && y % 4 === 0)) { monthLength[1] = 29 }
            return d > 0 && d <= monthLength[m - 1]
          },
        })
        this.$validator.extend('icLength', {
          getMessage (field, args) {
            return 'IC not in right length'        
          },
          validate (value, args) {
            return value.toString().length === 14
          },
        })
        this.$validator.extend('nameAllowedFormat', {
          getMessage (field, args) {
            return "Invalid name format. Only alphabet and special character of @ ' * - / . allowed for name"     
          },
          validate (value, args) {
            const regex = /^[ A-Za-z'@./*-]*$/
            return regex.test(value)
          },
        })        
        this.$validator.extend('validAlphanumeric', {
          getMessage (field, args) {
            return 'Income tax number should not contain any special character'     
          },
          validate (value, args) {
            const regex = /^[A-Z0-9]*$/
            return regex.test(value)
          },
        })    

        Promise.all([
          this.$api.hrisRelationships().list(),
          this.$api.hrisRelationStatuses().list(),
        ])
          .then(([employee, relationStatus]) => {
            this.relationships = employee.data
            this.relationStatuses = relationStatus.data

            this.loading = false
          })
      },
    },
    methods: { 
      prepareFormData () {
        if (this.relationStatus !== 4) {
          this.companyName = null
          this.occupation = null
          this.incomeTaxNo = null
        }

        if (this.relationStatus !== 2) {
          this.educationLevel = null
        }

        if (this.file) {
          this.file.formData.set('name', this.name)
          this.file.formData.set('ic', this.ic ? this.ic.replace(/-/g, '') : '')
          this.file.formData.set('relationship_id', this.relationship)
          this.file.formData.set('company_name', this.companyName ? this.companyName : '')
          this.file.formData.set('passport_no', this.passportNo ? this.passportNo : '')
          this.file.formData.set('relation_status_id', this.relationStatus)
          this.file.formData.set('birth_date', this.birthDate)
          this.file.formData.set('gender_lookup_uid', this.genderLookupUid)
          this.file.formData.set('is_disabled', this.isDisabled)
          this.file.formData.set('occupation', this.occupation ? this.occupation : '')
          this.file.formData.set('is_citizen', this.isCitizen)
          this.file.formData.set('is_tax_relief', this.relationship === 2 ? this.isTaxRelief : 1)
          this.file.formData.set('tax_relief_percentage', this.taxReliefPercentage)
          this.file.formData.set('income_tax_no', this.incomeTaxNo ? this.incomeTaxNo : '')
          this.file.formData.set('education_level', this.educationLevel)

          return this.file.formData
        }

        let formData = new FormData()

        formData.append('name', this.name)
        formData.append('ic', this.ic ? this.ic.replace(/-/g, '') : '')
        formData.append('passport_no', this.passportNo ? this.passportNo : '')
        formData.append('relationship_id', this.relationship)
        formData.append('company_name', this.companyName ? this.companyName : '')
        formData.append('relation_status_id', this.relationStatus)
        formData.append('birth_date', this.birthDate)
        formData.append('gender_lookup_uid', this.genderLookupUid)
        formData.append('is_disabled', this.isDisabled)
        formData.append('occupation', this.occupation ? this.occupation : '')
        formData.append('is_citizen', this.isCitizen)
        formData.append('is_tax_relief', this.relationship === 2 ? this.isTaxRelief : 1)
        formData.append('tax_relief_percentage', this.taxReliefPercentage)
        formData.append('income_tax_no', this.incomeTaxNo ? this.incomeTaxNo : '')
        formData.append('education_level', this.educationLevel)

        return formData
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.hrisDependents().create(this.employeeUid, this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.$resetData()
                  this.dialog = false       
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      getBirthdayFromIC (value) {
        let ic = value.replace(/-/g, '')

        if (ic.length === 12) {
          let date = value.substr(0, 6)
     
          if (Number(date.substr(0, 2)) >= 48) {
            this.birthDate = '19' + date.substr(0, 2) + '-' + date.substr(2, 2) + '-' + date.substr(4, 2)
          } else {
            this.birthDate = '20' + date.substr(0, 2) + '-' + date.substr(2, 2) + '-' + date.substr(4, 2)
          }

          let lastDigitIc = value.substr(value.length - 1, 1)
  
          if (['0', '2', '4', '6', '8'].includes(lastDigitIc)) {
            this.genderLookupUid = '1c66161e-dbe1-11e7-ba92-509a4c2dfbad'
          } else {
            this.genderLookupUid = '1c661585-dbe1-11e7-ba92-509a4c2dfbad'
          }
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border:2px solid red;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
